// extracted by mini-css-extract-plugin
export default {"logo":"NavContent_logo__Simk7","navPromptWrapper":"NavContent_navPromptWrapper__-lkGd"};